export enum ConnectionEvent {
  order = 'order',
  connection = 'connection'
}
